import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { FileData, FileType } from '../file-upload/file-upload.constants';
import { CONFIRM_DIALOG_LABELS } from './delete-file-confirmation.constants';

@Component({
  selector: 'app-delete-file-confirmation-popup',
  templateUrl: './delete-file-confirmation-popup.component.html',
  styleUrls: ['./delete-file-confirmation-popup.component.scss'],
  standalone: false,
})
export class DeleteFileConfirmationPopupComponent {
  readonly IMAGES = IMAGE_SRC;
  file: FileType;
  readonly CONSTANTS = { ...CONFIRM_DIALOG_LABELS };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FileData,
    public readonly dialogRef: MatDialogRef<DeleteFileConfirmationPopupComponent>,
  ) {
    this.file = this.data?.file;
  }

  onClose(button: string): void {
    this.dialogRef.close({ button });
  }
}
